import React from 'react'
import classnames from 'classnames'

type Props = {
  total: number
  activeIndex: number
}

export const DotIndicators = ({ total, activeIndex }: Props) => {
  if (total <= 1) {
    return null
  }

  const maxDots = 5

  // Show all dots if total is less than or equal to maxDots
  if (total <= maxDots) {
    return (
      <div className='dotIndicators' aria-hidden='true'>
        {Array.from({ length: total }, (_, index) => (
          <span
            key={index}
            className={classnames('dot', {
              active: index === activeIndex,
              adjacent: Math.abs(index - activeIndex) === 1
            })}
          />
        ))}
      </div>
    )
  }

  // Sliding window: keep active dot in the middle (position 3 of 5)
  const windowStart = Math.max(0, Math.min(activeIndex - 2, total - maxDots))

  return (
    <div className='dotIndicators' aria-hidden='true'>
      {Array.from({ length: maxDots }, (_, i) => {
        const index = windowStart + i
        return (
          <span
            key={index}
            className={classnames('dot', {
              active: index === activeIndex,
              adjacent: Math.abs(index - activeIndex) === 1
            })}
          />
        )
      })}
    </div>
  )
}
